<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="lookup-form">
      <v-card class="mx-auto w-full lookup-form__card" flat max-height="auto" max-width="1000">
        <div class="lookup-form__grid flex flex-wrap my-2 mx-6 mb-4">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >University Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="name"
                  v-model="formValues.name"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0 required">
            <label
                class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
            >Ownership</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.ownershipId"
                  :elevation="1"
                  :items="OWNERSHIPS"
                  :loading="lookupLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0 required">
            <label
                class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
            >Generation</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.generation"
                  :elevation="1"
                  :items="GENERATION_LEVELS"
                  :loading="lookupLoading"
                  dense
                  item-text="name"
                  item-value="name"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0 required">
            <label
                class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
            >Institution Type</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.institutionType"
                  :elevation="1"
                  :items="INSTITUTION_TYPES"
                  :loading="lookupLoading"
                  dense
                  item-text="name"
                  item-value="name"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0 required">
            <label
                class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
            >Region</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.regionId"
                  :elevation="1"
                  :items="REGIONS"
                  :loading="lookupLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
            >Town</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="town"
                  v-model="formValues.town"
                  class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >University Code</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="code"
                  v-model="formValues.code"
                  :disabled="true"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >University's Status</label
            >
            <validation-provider v-slot="{ errors }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-switch
                      v-model="formValues.isActive"
                      color="green"
                      hide-details
                      v-on="on"
                  ></v-switch>
                </template>
                <span>{{ formValues.isActive == true ? 'Active' : 'Not Active' }}</span>
              </v-tooltip>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="lookup-form__actions">
          <v-btn class="lookup-form__cancel" text type="button" @click="$emit('close')">
            Cancel
          </v-btn>
          <v-btn
              :disabled="formValues.code === null"
              class="lookup-form__submit white--text"
              color="primary"
              depressed
              @click="submit()"
          >
            {{ formValues.editMode ? "Update" : "Add" }}
          </v-btn>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import {getGenerationLevels, getRegionList, getUniversityOwnership} from "@/utils/helper";

extend("required", {
  ...required,
  message: "This field is required",
});
export default {
  props: {
    university: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        name: "",
        ownershipId: null,
        regionId: null,
        generation: "",
        town: "",
        institutionType: "",
        code: null,
        isActive: true,
        editMode: false,
      },
      today: new Date().toISOString().substr(8, 11),
      disableAdd: true,

      OWNERSHIPS: [],
      GENERATION_LEVELS: [],
      INSTITUTION_TYPES: [
        {name: "University"},
        {name: "Collage"},
        {name: "University Collage"},
      ],
      REGIONS: [],
      lookupLoading: false,
    };
  },
  async created() {
    if (this.university != null) {
      this.formValues = this.university;
      this.formValues.editMode = true;
    }

    this.lookupLoading = true;
    this.OWNERSHIPS = await getUniversityOwnership();
    this.GENERATION_LEVELS = await getGenerationLevels();
    this.REGIONS = await getRegionList();
    this.lookupLoading = false;
  },
  methods: {
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("registerOrUpdateUniversity", this.formValues);
      this.$emit("close");
    },
  },
  watch: {
    "formValues.name": function (event) {
      if (this.formValues.editMode !== true) {
        const tempEvent = event.toUpperCase();
        const subEventName = tempEvent.replace(/\s/g, "").substring(0, 3);
        const generatedCode =
            subEventName == null || subEventName == ""
                ? null
                : subEventName + `${this.today.replace(/\s+|T|:/g, "")}`;
        this.formValues.code = generatedCode
            ? generatedCode.replace(/-/g, "")
            : null;
      }
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}

input:disabled {
  background: #ccc;
}
</style>
